<div class="mb-3 row"> <label for="name" class="col-md-4 control-label text-start">{{'FRAMENUMBER'|translate}}
    *</label>
  <div class="col-md-4" [formGroup]="formGroup"> <input type="text" class="form-control framenumber bg-white" readonly
      formControlName="framenumber" name="framenumber" (click)="inputClick()">
  </div>
</div>
